import { SvgIcon } from '@/components/svgIcon';
import { linkToString } from '@/helper/urls';
import ArrowIcon from '@/public/icons/material/arrow-forward-rounded.svg';
import React from 'react';

import classes from './SearchResultItem.module.scss';

export type SearchResultItemProps = {
  subtitle: string;
  title: string;
  link: string;
  searchTerm?: string;
  ref?: React.Ref<HTMLAnchorElement>;
};

// eslint-disable-next-line react/display-name
const SearchResultItem = React.forwardRef<HTMLAnchorElement, SearchResultItemProps>(
  ({ subtitle, title, link, searchTerm }, ref) => {
    return (
      <a
        data-testid="search-result-item-link"
        className={classes.searchResultItem}
        href={linkToString(link)}
        ref={ref}
        tabIndex={0}
      >
        <div>
          <div className={classes.subtitle}>{subtitle}</div>

          <div className={classes.title}>
            <span dangerouslySetInnerHTML={{ __html: title }} />
          </div>
        </div>

        <SvgIcon component={ArrowIcon} className={classes.arrowIcon} aria-hidden />
      </a>
    );
  }
);

export default SearchResultItem;
